import { apiClient } from '@/shared/lib/apiClient';
import type {
  AdminBookingDetail,
  AdminBookingRow,
  AdminBookingStats,
  ApiResponse,
  PaginatedResponse,
} from '@/types';

export interface AdminBookingListParams {
  page?: number;
  limit?: number;
  statuses?: string;
  q?: string;
  dateField?: 'createdAt' | 'travelDate';
  from?: string;
  to?: string;
  attention?: boolean;
  sortBy?: string;
}

export const adminBookingsApi = {
  async list(params: AdminBookingListParams) {
    const res = await apiClient.get<PaginatedResponse<AdminBookingRow>>('/admin/bookings', {
      params: { ...params, attention: params.attention ? 'true' : undefined },
    });
    return { data: res.data.data, pagination: res.data.pagination };
  },

  async stats() {
    const res = await apiClient.get<ApiResponse<AdminBookingStats>>('/admin/bookings/stats');
    return res.data.data!;
  },

  async getById(id: string) {
    const res = await apiClient.get<ApiResponse<AdminBookingDetail>>(`/admin/bookings/${id}`);
    return res.data.data!;
  },
};

export const adminBookingsKeys = {
  all: ['admin-bookings'] as const,
  list: (params: AdminBookingListParams) => [...adminBookingsKeys.all, 'list', params] as const,
  stats: () => [...adminBookingsKeys.all, 'stats'] as const,
  detail: (id: string) => [...adminBookingsKeys.all, 'detail', id] as const,
};
